import { render, staticRenderFns } from "./sdk.vue?vue&type=template&id=70deea80&scoped=true&"
import script from "./sdk.vue?vue&type=script&lang=js&"
export * from "./sdk.vue?vue&type=script&lang=js&"
import style0 from "./sdk.vue?vue&type=style&index=0&id=70deea80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70deea80",
  null
  
)

export default component.exports